export default __webpack_public_path__ + "static/formImg-8de97775f279f0f27f74300a536c94eb.jpg";